import React, { Component } from 'react';
import { connect } from 'react-redux';
import format from 'format-number';
import { updateIncomeExpenses } from '../../../../actions/incomeExpensesAction';
import {isMobile} from 'react-device-detect';

import InlineEdit from '../../../../components/InlineEdit/InlineEdit';
import CreditCardsField from '../../../../components/Fields/IncomeExpenses/CreditCardsField';
import StaticField from '../../../../components/StaticField/StaticField';
import SaveDialog from '../../../../components/SaveDialog/SaveDialog';

import {INCOMEEXPENSES, INCOMEEXPENSES_CREDITCARDS} from '../../../../utils/FieldTypes';


class InlineEditCreditCards extends Component {
  constructor(props) {
    super(props);

    this.state = {
      edit: false,
      saveDialogOpen: false
    };
    this.handleChange = this.handleChange.bind(this);
    this.validateField = this.validateField.bind(this);
    this.onClickSave = this.onClickSave.bind(this);
    this.toggleEdit = this.toggleEdit.bind(this);
    this.cancelEdit = this.cancelEdit.bind(this);
    this.toggleSaveDialog = this.toggleSaveDialog.bind(this);
  }
  handleChange(event) {
    this.props.handleChange(INCOMEEXPENSES, event);
  }
  validateField(event) {
    this.props.validateField(INCOMEEXPENSES, event);
  }
  onClickSave(event) {
    event.preventDefault();
    this.props.validateFields(INCOMEEXPENSES, ["creditcards"], (isValid) => {
      if(isValid) {        
        this.props.updateIncomeExpenses({creditcards: this.props.creditcards});
        this.toggleEdit();
      }
      else {
        this.setState({
          saveDialogOpen: false
        })
      }
    });
  }
  toggleEdit() {    
    this.props.updateFieldsFromSavedState(INCOMEEXPENSES_CREDITCARDS);
    this.props.countOpenSections(!this.state.edit);
    this.setState({
      edit: !this.state.edit,
      saveDialogOpen: false
    });
  }
  cancelEdit() {
    if(this.props.creditcards === this.props.savedIncomeExpenses.creditcards) {
      this.toggleEdit();
    }
    else {
      this.setState({
        saveDialogOpen: true
      })
    }
  }
  toggleSaveDialog() {
    this.setState({
      saveDialogOpen: !this.state.saveDialogOpen
    });
  }
  render() {
    let creditcards;

    if(this.props.savedIncomeExpenses.creditcards !== undefined) {
      creditcards = format({prefix: '$', suffix: ' / month'})(this.props.savedIncomeExpenses.creditcards);
    }    
    return (
      <div className="review-inline-edit">
        {!this.state.edit ? 
          <StaticField label="Credit Cards" value={creditcards} onClickEdit={this.toggleEdit} hidden={this.state.edit} disableEdit={this.props.sectionsOpen} />        
        :
          <InlineEdit onClickSave={this.onClickSave} hidden={!this.state.edit} onClickCancel={this.cancelEdit}>  
            <CreditCardsField {...this.props} handleChange={this.handleChange} onBlur={this.validateField} error={this.props.validation.creditcards.isInvalid} errorMessage={this.props.validation.creditcards.message} autoFocus={!isMobile} />
          </InlineEdit>
        }
        <SaveDialog visible={this.state.saveDialogOpen} toggle={this.toggleSaveDialog} name="Income &amp; Expenses" onClickSave={this.onClickSave} onClickCancel={this.toggleEdit} />
      </div>);
  }
}

const mapStateToProps = state => ({
})

const mapDispatchToProps = dispatch => ({
  updateIncomeExpenses: (incomeExpenses) => dispatch(updateIncomeExpenses(incomeExpenses))
})

export default connect(mapStateToProps, mapDispatchToProps)(InlineEditCreditCards);


// WEBPACK FOOTER //
// ./src/containers/Review/InlineEdit/IncomeExpenses/CreditCards.js